<template>
  <form @submit.prevent="handleFormSubmit" class="change-password">
    <h1 class="change-password__heading">{{ $t("enter new password") }}</h1>
    <div class="change-password__input-container">
      <input
        v-model="password"
        type="password"
        :placeholder="$t('password')"
        class="change-password__input"
      />
    </div>
    <div class="change-password__input-container">
      <input
        v-model="repeatedPassword"
        type="password"
        :placeholder="$t('repeat password')"
        class="change-password__input"
      />
    </div>
    <button
      type="submit"
      class="button filled change-password__submit-button"
      :class="{ disabled: !passwordIsValid }"
    >
      {{ $t("change password") }}
    </button>
    <p
      v-show="!passwordsAreEqual"
      class="change-password__not-equality-message"
    >
      {{ $t("passwords must match") }}
    </p>
  </form>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      repeatedPassword: ""
    };
  },
  computed: {
    passwordsAreEqual() {
      return this.password === this.repeatedPassword;
    },
    passwordIsValid() {
      // Минимальная длина пароля - 6 символов
      return this.password.length >= 6 && this.passwordsAreEqual;
    }
  },
  methods: {
    handleFormSubmit() {
      // Если пароль не прошел валидацию, прерываем выполнение функции
      if (!this.passwordIsValid) {
        return;
      }
      this.$store.dispatch("resetPassword", this.password);
    }
  }
};
</script>

<style scoped>
.change-password {
  display: flex;
  flex-direction: column;
}

.change-password__heading {
  margin-bottom: 20px;
  font-weight: normal;
  font-size: 36px;
}

.change-password__input-container {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.change-password__input {
  width: 100%;
  padding: 10px;
  font-size: 15px;
  outline: none;
  background-color: #ffffff;
  border: 1px solid #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.change-password__not-equality-message {
  margin-top: 20px;
  text-align: center;
  color: #ef4748;
}

.change-password__submit-button {
  margin-top: 20px;
  font-size: 16px;
  padding: 15px 30px;
}
</style>
